// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"24253": "37283bae","36423": "c9a78907","37002": "f3c36a75",}[chunkId] + ".css"
}